import { useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { lastFiveDigitsComparator, titleCase } from '../../../common/commonFunction';
import { DialogContent, Dialog, DialogActions, Button } from '@mui/material';
import { PROD, RESOURCE_ROLES } from '../../../common/constants';
import { Container, Stack, Box, Typography, Grid, Card, CardContent, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../../common/customDataGridToolbar';
import { getAllState, getAllDistrict, getAllRevenueCircle, growersVacantLandList } from '../resourceCommonAPIs';
import { CATEGORY_ERROR, ITEM_TYPE_ERROR, STATE_ERROR, DISTRICT_ERROR, REVENUE_CIRCLE_ERROR, ROUTE_TYPE_ERROR, UNIT_PER_ERROR, CREATE_RATE_CARD, STAKEHOLDER_URN, STAKEHOLDER_NAME, REGISTRATION_NO, VEHICLE_TYPE, VEHICLE_CAPACITY, VEHICLE_MAKE, VEHICLE_MODEL, ROUTE, LAND_NAME, ITEM_RATE, SUBMIT, CATEGORY, ITEM_TYPE, ROUTE_TYPE, STATE, DISTRICT, REVENUE_CIRCLE, UNIT_PER, ITEM_RATE_MASS_ENTRY, INSERT_ALL, NO_DATA_AVAILABLE, PROCEED } from '../../../common/constants';
import BackButton from '../../../common/backButton';
import { getLocalStorageItem } from "../../../common/localStorageUtils";

function GrowersList() {
  const navigate = useNavigate();
  const location = useLocation();
  const role = getLocalStorageItem('role');
  const RolesToDisable = [RESOURCE_ROLES?.PlantSCMMember, RESOURCE_ROLES?.ModuleIncharge].includes(role);
  const [chooseState, setchooseState] = useState([]);
  const [chooseDistrict, setChooseDistrict] = useState([]);
  const [chooseRevenueCircle, setChooseRevenueCircle] = useState([]);
  const [proceed, setProceed] = useState(false);
  const [details, setDetails] = useState({
    state: "",
    district: "",
    revenueCircle: ""
  });
  const [errorMessage, setErrorMessage] = useState({
    stateError: '',
    districtError: ''
  });
  const [growersList, setGrowersList] = useState([]);

  useEffect(() => {
    getAllState(setchooseState);

    const locationData = location?.state;

    if (locationData?.shouldRestoreGrowersList) {
      setDetails(locationData.details || { state: "", district: "", revenueCircle: "" });
      setGrowersList(locationData.growersList || []);
      setProceed(locationData.proceed || false);

      if (locationData.details?.state) {
        getAllDistrict(locationData.details.state, setChooseDistrict);
      }

      if (locationData.details?.district) {
        getAllRevenueCircle(locationData.details.district, setChooseRevenueCircle);
      }

      sessionStorage.removeItem("growersListData");
    } else {
      sessionStorage.removeItem("growersListData");
      setDetails({ state: "", district: "", revenueCircle: "" });
      setGrowersList([]);
      setProceed(false);
      setChooseDistrict([]);
      setChooseRevenueCircle([]);
    }
  }, []);

  useEffect(() => {
    if (proceed) {
      sessionStorage.setItem(
        "growersListData",
        JSON.stringify({
          details,
          growersList,
          proceed
        })
      );
    }
  }, [details, growersList, proceed]);

  const handleChange = (e) => {
    if (e.target.name === "state") {
      getAllDistrict(e.target.value, setChooseDistrict);
      setChooseRevenueCircle([]);
      setDetails({ ...details, state: e.target.value, district: "", revenueCircle: "" });
      setErrorMessage({ ...errorMessage, stateError: "", districtError: "" });
    }

    if (e.target.name === "district") {
      getAllRevenueCircle(e.target.value, setChooseRevenueCircle);
      setDetails({ ...details, district: e.target.value, revenueCircle: "" });
      setErrorMessage({ ...errorMessage, districtError: "" });
    }

    if (e.target.name === "revenueCircle") {
      setDetails({ ...details, revenueCircle: e.target.value });
    }
  };

  const onProceed = () => {
    setProceed(true);
    if (!details.state) {
      setErrorMessage({ ...errorMessage, stateError: "Please enter state" });
    } else if (!details.district) {
      setErrorMessage({ ...errorMessage, districtError: "Please enter district" });
    } else {
      growersVacantLandList(details, setGrowersList);
    }
  };

  const columns = [
    { field: 'name', headerName: "Grower Name", width: 200 },
    { field: 'urn', headerName: "URN", width: 200, sortComparator: (a, b) => lastFiveDigitsComparator(a, b) },
    { field: 'landName', headerName: "Land Name", width: 200 },
    { field: 'landArea', headerName: "Existing Land Area(in Bigha)", width: 250 },
    { field: 'availableLandArea', headerName: "Available Land Area(in Bigha)", width: 250 },
    {
      field: 'actions',
      headerName: "Action",
      width: 280,
      renderCell: (params) => {
        return (
          <Button
            sx={{ minWidth: 100 }}
            disabled={params?.row?.isApprovedGrower === "N" || params?.row?.landAvailableFlag === 'N' || RolesToDisable}
            variant="contained"
            onClick={() => {
              const growersListData = {
                shouldRestoreGrowersList: true,
                details,
                growersList,
                proceed: true
              };

              sessionStorage.setItem("growersListData", JSON.stringify(growersListData));

              navigate("plantationSponsored", {
                state: {
                  landName: params?.row?.landName,
                  landId: params?.row?.landId,
                  possibleClumpsToGrow: params?.row?.possibleClumpsToGrow,
                  urn: params?.row?.urn,
                  growerName: params?.row?.name,
                  landArea: params?.row?.landArea,
                  availableLandArea: params?.row?.availableLandArea,
                  growerType: params?.row?.growerType,
                  state: params?.row?.state,
                  district: params?.row?.district,
                  backTo: "/resourcedashboard/plantationHome/scmMemberCreatePlant"
                }
              });
            }}
          >
            Create Plantation
          </Button>
        );
      }
    },
  ];

  return (
    <Container maxWidth="xxl">
      {!PROD && <p className='pageNumberingResc'>RES05</p>}
      <Stack direction="row" alignItems="center" spacing={1} mb={1}>
        <BackButton navigate={navigate} />
        <Typography variant="h5" gutterBottom>
          Growers List
        </Typography>
      </Stack>
      <Card>
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={12} lg={3}>
              <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={proceed && !details?.state}>
                <InputLabel>{STATE}</InputLabel>
                <Select
                  label={STATE}
                  name="state"
                  value={details?.state || ''}
                  onChange={handleChange}
                >
                  <MenuItem value=""><em>{STATE}</em></MenuItem>
                  {chooseState?.map((statename) => (
                    <MenuItem key={statename} value={statename}>
                      {statename && titleCase(statename)}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText sx={{ color: 'red' }}>{errorMessage?.stateError}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={3}>
              <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={proceed && !details?.district}>
                <InputLabel>{DISTRICT}</InputLabel>
                <Select
                  label={DISTRICT}
                  name="district"
                  value={details?.district || ''}
                  onChange={handleChange}
                >
                  <MenuItem value=""><em>{DISTRICT}</em></MenuItem>
                  {chooseDistrict?.map((districtname) => (
                    <MenuItem key={districtname} value={districtname}>
                      {districtname && titleCase(districtname)}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText sx={{ color: 'red' }}>{errorMessage?.districtError}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={3}>
              <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                <InputLabel>{REVENUE_CIRCLE}</InputLabel>
                <Select
                  label={REVENUE_CIRCLE}
                  name="revenueCircle"
                  value={details?.revenueCircle || ''}
                  onChange={handleChange}
                >
                  <MenuItem value=""><em>Select</em></MenuItem>
                  {chooseRevenueCircle?.map((revenueCirclename) => (
                    <MenuItem key={revenueCirclename} value={revenueCirclename}>
                      {titleCase(revenueCirclename)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} lg={2} mt={1}>
              <Button sx={{ minWidth: 100 }} variant="contained" onClick={onProceed}>
                {PROCEED}
              </Button>
            </Grid>

            <Grid item xs={12} lg={12} mt={2}>
              {proceed && (
                <DataGrid
                  autoHeight
                  rows={growersList}
                  columns={columns}
                  getRowId={(row) => row?.landId}
                  pageSize={10}
                  components={{ Toolbar: CustomDataGridToolbar }}
                  componentsProps={{
                    toolbar: {
                      rows: growersList,
                      columns: columns,
                      fileName: "GrowersList.xlsx"
                    }
                  }}
                />
              )}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Container>
  );
}

export default GrowersList;